
    <navbar-container></navbar-container>
    <main>
      <router-outlet></router-outlet>
    </main>
  